import { render, staticRenderFns } from "./BusinessGroupView.vue?vue&type=template&id=ac8441f4&lang=pug&"
import script from "./BusinessGroupView.vue?vue&type=script&lang=js&"
export * from "./BusinessGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports